import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media, layout } from 'src/components/base';

const basePadding = '20px';

export const Banner = styled.div`
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: ${basePadding};
  background-position: center center;
  background-size: cover;
  color: white;
  text-align: center;

  flex-direction: column;
  ${media.mediumUp`
    flex-direction: row;
  `};
`;

export const BadgeSection = styled.div`
  box-sizing: content-box;
  flex: 0 0 auto;

  padding: ${basePadding};
  padding-bottom: 0;
  ${media.mediumUp`
    padding-bottom: ${basePadding};
    padding-right: calc(${basePadding} * 2);
    border-right: 1px solid white;
  `};
`;

export const BadgeImage = styled.img`
  max-width: 200px;
  ${media.mediumUp`
    max-width: 300px;
    min-width: 200px;
  `};
`;

export const MainSection = styled.div`
  padding: ${basePadding};
  max-width: 600px;
  margin: 0 auto;
  ${media.mediumUp`
    padding-left: calc(${basePadding} * 2);
  `};
`;

export const Description = styled.p`
  margin-bottom: ${basePadding};
`;

export const Button = styled(Link)`
  color: ${p => p.theme.colors.base0};
  border: 1px solid currentColor;
  border-radius: ${layout.borderRadius};
  display: inline-block;
  font-weight: 600;
  outline: none;
  padding: 10px 20px;
  transition: box-shadow 0.1s linear;

  :hover,
  :focus {
    color: ${p => p.theme.colors.base200};
  }

  :focus {
    box-shadow: 0 0 0 2px currentColor;
  }
`;
